import {
    widthProp,
    maxSizeDesktop,
    spacingMedium,
    spacingSmall,
    spacingExtraSmall,
    spacingExtraLarge,
} from 'helpers/style';

import { Flex } from 'lib/components/Flex';
import { TextMedium } from 'lib/common/text';
import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const MainContainer = styled(Flex)`
    flex: 1;
`;

export const Content = styled.div`
    min-height: 600px;
    min-width: 100%;
    background-color: ${(p) => p.theme.color.grayDark3};
`;

export const DataRow = styled(Flex)`
    ${(p) => css`
        background-color: ${p.theme.color.grayDark3};
        border: 1px solid ${p.theme.color.grayDark};
        border-top: 0px;
        align-items: center;
        width: 100%;
    `};
    flex-wrap: wrap;
    &:not(:first-of-type) {
        border-top: none;
    }

    padding: 0 ${spacingExtraLarge};
    ${maxSizeDesktop} {
        padding: 0 ${spacingMedium};
    }

    height: 100%;
`;

export const Header = styled(Flex)`
    padding: ${spacingSmall};
    ${maxSizeDesktop} {
        padding: ${spacingExtraSmall};
    }
    flex-wrap: wrap;
    ${(p) => css`
        background-color: ${p.theme.color.gray3};
        border-top-left-radius: ${p.theme.borderRadius.medium};
        border-top-right-radius: ${p.theme.borderRadius.medium};
    `};
`;

export const Column = styled.div`
    ${(props) => (props.autoWidth ? `flex: 1` : '')};

    padding-right: ${spacingMedium};
    ${maxSizeDesktop} {
        padding-right: ${spacingSmall};
    }
    font-weight: ${(props) => (props.bold ? 'bold' : 'normal')};
    font-family: ${({ bold, theme }) => (bold ? theme.font.mono : theme.font.regular)};
    font-size: 13px;
    line-height: 18px;
    align-items: ${(props) => (props.center ? 'center' : 'flex-start')};
    ${widthProp};
`;
Column.defaultProps = {};

export const CodeColumn = styled(Column)`
    font-weight: bold;
`;

export const IconColumn = styled(Column)`
    align-items: center;
`;

export const DateColumn = styled(Column)`
    color: ${(p) => p.theme.color.gray2};
    min-width: 80px;
    padding-right: 0;
`;

export const LabelColumn = styled(Column)`
    min-width: 35px;
    font-weight: bold;
`;

export const MessageColumn = styled(Column)`
    min-width: 200px;
`;

export const CategoryButton = styled(Flex)`
    flex: 1 0 120px;

    border-radius: 3px;
    background-color: ${(p) => (p.inActive ? p.theme.color.white : p.theme.color.grayDark)};
    color: ${(p) => (p.inActive ? p.theme.color.grayDark : p.theme.color.white)};
    cursor: pointer;
    white-space: nowrap;
    justify-content: space-between;

    padding: 16px 8px;
    margin:${spacingSmall};
    ${maxSizeDesktop} {
        margin: ${spacingExtraSmall};
    }
    
    @media (min-width: ${(p) => p.theme.breakpoint.tablet}px) {
        padding: 8px;
    }

    svg {
        display: inline-block;
        vertical-align: middle;
        margin-right: 5px;
        margin-bottom: 2px;
    }

    ${TextMedium} {
        display: flex;
        align-items: center;
    }

    .header {
        margin-right: 12px;
    }
}`;

CategoryButton.defaultProps = { blacklist: ['inActive'] };
